import Anchor from "../../../../lib/html5-software-library/src/ranj/layout/Anchor";

export default class DisplayObjectUtil {
    /**
     * Sets the registration point of given display object to given anchor
     * @param {createjs.DisplayObject} displayObject 
     * @param {Anchor|createjs.Point} anchor 
     * @returns {createjs.DisplayObject}
     */
    static anchorDisplayObject(displayObject, anchor) {
        if (!(displayObject instanceof createjs.DisplayObject)) {
            console.warn(`[DisplayObjectUtil] Can only anchor classes inheriting from 'createjs.DisplayObject'. Ignoring request.`);
            return displayObject;
        }

        const bounds = displayObject.getBounds() || displayObject.nominalBounds;
        displayObject.regX = bounds.width * anchor.x;
        displayObject.regY = bounds.height * anchor.y;

        return displayObject;
    }
}